import { init } from '@edicom/web-components/core/core.js';

import { onChangeLanguage } from '../../shared/DOM/onChangeLanguage.js';
import { removePageLoader } from '../../shared/DOM/removePageLoader.js';
import { RESULT_REDIRECT_DIRECTLY } from './src/form/constant.js';

init(async () => {
  const { login } = await import('./src/login.js');
  const result = await login();

  if (RESULT_REDIRECT_DIRECTLY !== result) {
    onChangeLanguage();
    removePageLoader();
  }
});
